<template>
  <span class="admin-brand-logo" aria-label="On the Clock Now">
    <img src="@/assets/logo.png" alt="" />
    <span class="admin-brand-logo__words">
      <strong>On the</strong>
      <strong>Clock Now</strong>
    </span>
  </span>
</template>

<script>
export default {
  name: "AdminBrandLogo",
};
</script>

<style scoped>
.admin-brand-logo {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 1;
}

.admin-brand-logo img {
  width: 38px;
  height: 38px;
  object-fit: contain;
}

.admin-brand-logo__words {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  text-transform: uppercase;
}

.admin-brand-logo__words strong {
  color: #e8eef7;
  font-size: 14px;
  font-weight: 850;
  letter-spacing: 0.8px;
}

.admin-brand-logo__words strong:last-child {
  color: #22d3ee;
}

.theme--light .admin-brand-logo__words strong {
  color: #334155;
}

.theme--light .admin-brand-logo__words strong:last-child {
  color: #0891b2;
}

@media (max-width: 600px) {
  .admin-brand-logo {
    gap: 6px;
  }

  .admin-brand-logo img {
    width: 32px;
    height: 32px;
  }

  .admin-brand-logo__words strong {
    font-size: 11px;
    letter-spacing: 0.6px;
  }
}
</style>
